@use 'styles/functions/rem' as *;

.emptyState {
    align-items: center;
    color: var(--empty-state-color);
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: rem(40px);
    text-align: center;
}

.icon {
    align-items: center;
    color: var(--empty-state-icon-color);
    display: flex;
    height: rem(56px);
    justify-content: center;
    margin-bottom: rem(16px);
    opacity: 0.3;
    width: rem(56px);
}

.heading {
    color: var(--empty-state-heading-color);
    font-size: rem(15px);
    font-weight: 500;
    margin: 0 0 rem(4px);
}

.description {
    color: var(--empty-state-description-color);
    font-size: rem(13px);
    margin: 0;
    max-width: rem(300px);
}

.compact {
    padding: rem(20px);

    .heading {
        font-size: rem(13px);
        font-style: italic;
    }
}
